import { VisitorStatusType, VisitorSourceType, VisitorBadgeStatusType } from '@/api';

// Человекочитаемые (RU) подписи статусов посетителя.
// Используются в списке посетителей и в фильтре по статусу.
export const statusLabels = {
  [VisitorStatusType.Initial]: 'Добавлен',
  [VisitorStatusType.Invited]: 'Приглашён',
  [VisitorStatusType.Recorded]: 'Зарегистрирован',
  [VisitorStatusType.Confirmed]: 'Подтверждён',
  [VisitorStatusType.Come]: 'Пришёл',
  [VisitorStatusType.Canceled]: 'Отмена регистрации',
};

export const statusLabel = status => statusLabels[status] || status || '';

export const sourceLabels = {
  [VisitorSourceType.Manual]: 'Вручную',
  [VisitorSourceType.Imported]: 'Импорт',
  [VisitorSourceType.OnLine]: 'Онлайн-регистрация',
  [VisitorSourceType.OnSite]: 'Стойка регистрации',
  [VisitorSourceType.Chat]: 'Чат',
};

export const sourceLabel = source => sourceLabels[source] || source || '';

export const badgeStatusLabels = {
  [VisitorBadgeStatusType.NoBadge]: 'Не напечатан',
  [VisitorBadgeStatusType.Printed]: 'Напечатан',
};

export const badgeStatusLabel = status => badgeStatusLabels[status] || status || '';

// Все статусы в порядке жизненного цикла посетителя.
export const statusOptions = Object.values(VisitorStatusType);

// Статусы для фильтра — Invited не показываем, т.к. не используется.
export const statusFilterOptions = statusOptions.filter(s => s !== VisitorStatusType.Invited);
